export enum ElasticSearchIndex {
  PROCESS = 'processes'
}

export enum EEsGlobalSearchCollection {
  PROCESS = 'Process',
  COLLECTION = 'Collection'
}

export enum EEsIndex {
  GLOBAL_SEARCH = 'global_search'
}
